import * as React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { FC } from 'react';
import { LabelValue } from '../../types/common';

interface IButtons extends LabelValue {
  onClick?: (event: React.MouseEvent<HTMLElement>, value: any) => void
}
interface IProps {
  buttons: IButtons[];
  onChange: (arg: string) => void,
  value: string;
}

export const ToggleButtonGroup: FC<IProps> = ({
  buttons, onChange, value
}) => {
  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: string | null
  ): void => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };
  return (
      <MuiToggleButtonGroup
          color="primary"
          value={value}
          size="small"
          exclusive
          onChange={handleChange}
      >
        {buttons.map(button => (<ToggleButton {...(button.onClick ? { onClick: button.onClick } : {})} key={button.value} value={button.value}>{button.label}</ToggleButton>))}

      </MuiToggleButtonGroup>
  );
}
